<!--
	@Date of create:  2020/4/23
	@Founder: yuxinkai
	@Description:	1.头部组件
-->
<template>
  <div>
    <!-- <div class="topBar">
      <van-row>
        <van-col :span="2">
          <a class="el-icon-arrow-left topBarImg" @click="goBack" />
        </van-col>
        <van-col :span="20" style="text-align: center">
          <p>{{ titleName }}</p>
        </van-col>
        <van-col :span="2"> </van-col>
      </van-row>
    </div> -->

    <van-cell-group class="navShow">
			<van-row type="flex" justify="center">
         <van-col :span="2">
          <a class="el-icon-arrow-left topBarImg" @click="goBack" />
        </van-col>
        <van-col :span="20" class="titicon">
          {{ titleName }}
        </van-col>
        <van-col :span="2"> </van-col>
			</van-row>
		</van-cell-group>

  </div>
</template>
<script>
export default {
  name: "backHeader",
  props: {
    titleName: String,
    flag:{
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      if(this.flag == 'DHZYYDD'){
        this.$router.push({
          name: this.flag
        })
      }else{
        this.$router.go(-1);
      }
    }
  },
};
</script>
<style scoped>
.topBar {
  height: 1.2rem;
  /* background: linear-gradient(90deg, #3eb2e7, #05469c); */
  color: #fff;
  font-size: 0.5rem;
  line-height: 1.2rem;
}
.topBar p {
  display: inline;
}
.topBarImg {
  height: 0.5rem;
  line-height: 1.2rem;
  font-weight: bold;
}
.bottomBar {
  height: 1rem;
}
.bottomBar .el-button {
  width: 100%;
  background-color: #384c9b;
  color: #fff;
  font-size: 0.25rem;
}
.cancel {
  background-color: #2f2;
}
.delete {
  background-color: #f22;
}
</style>